// // /FRONTEND/src/components/Concenr/TechConcernsResolution.jsx

// /FRONTEND/src/components/Concenr/TechConcernsResolution.jsx

import React from "react";
import { useState, useEffect, useContext } from "react";
import { Card, Row, Col, Form, Table, Container, Button } from "react-bootstrap";
import Select from "react-select";
import { UserContext } from "../contextAPIs/User.context";
import {
  SchoolContext,
  BlockContext,
  DistrictBlockSchoolContext,
  ClassContext,
} from "../contextAPIs/DependentDropdowns.contextAPI";
import {
  getConcernsByQueryParameters,
  getConcernsPipeLineMethod,
  PatchConcernsByQueryParams,
} from "../../service/ConcernsServices/Concern.services";
import {
  District,
  DistrictBlockSchoolById,
  ClassOfStudent,
} from "../DependentDropDowns/DistrictBlockSchool.component";
import { DistrictDropdown, SchoolDropdown, DistrictSchoolDropdown } from "../../components/DependentDropDowns/DistrictBlockSchoolVersion2.component.jsx";



import { getIndividualConcerns } from "../../service/ConcernsServices/Concern.services";

export const SchoolConcernsResolution = () => {
  //Context apis
  const { userData, setUserData } = useContext(UserContext);

  const { districtContext, setDistrictContext } = useContext(DistrictBlockSchoolContext); // Use context

  const { blockContext, setBlockContext } = useContext(BlockContext); // Use context

  const { schoolContext, setSchoolContext } = useContext(SchoolContext); // Use context

  const { classContext, setClassContext } = useContext(ClassContext);

  //Usestate hooks.
  const [concernData, setConcernData] = useState([]);
  const [statusSelections, setStatusSelections] = useState({});
  const [comment, setComment] = useState(""); // added comment field








//--------------------------------------------------------------------------

const regions = userData?.userAccess?.region || [];
const allSchoolIds = regions.flatMap(region =>
  region.blockIds.flatMap(block =>
    block.schoolIds.map(school => school.schoolId)
  )
);

const allDistrictIds = regions.flatMap(region => 
  region.districtId
)

console.log(allDistrictIds)

//------------------------------------------------------------------------


  //API to fetch concerns data. Tech Concerns Only.
  const fetchTechConcerns = async () => {
    let conditionalRole;
    let conditionalDepartment;

    if (userData?.role === "ACI") {
      conditionalRole = ["CC"];
      conditionalDepartment = ["Community"];
    } else if (
      userData?.role === "Community Incharge" ||
      userData?.role === "Project Coordinator"
    ) {
      conditionalRole = ["ACI", "CC"];
      conditionalDepartment = ["Community"];
    } else if (
      userData?.role === "admin" ||
      userData?.role === "Community Manager"
    ) {
      conditionalRole = ["ACI", "CC", "Community Incharge"];
      conditionalDepartment = ["Community"];
    }

    const queryParams = {
      userId: userData?.userId,
      concernType: "School-Individual-Student",
      role: userData?.role,
      conditionalRole: conditionalRole,
      conditionalDepartment: conditionalDepartment,
      districtId: districtContext?.[0]?.value || "",
      blockId: blockContext?.[0]?.value || "",
      schoolId: schoolContext?.[0]?.value || "",
      classOfConcern: classContext?.value || "",
    };

    console.log(queryParams);
    try {
      const response = await getConcernsPipeLineMethod(queryParams); //getConcernsByQueryParameters

      console.log(response.data.data);

      setConcernData(response.data.data);
    } catch (error) {
      console.log("Error fetching concerns", error);
    }
  };

  useEffect(() => {
    fetchTechConcerns();
  }, [classContext, districtContext, schoolContext]);

  //dependencie of DistrictBlockSchoolById

  const assignedDistricts = userData?.[0]?.assignedDistricts;

  //React selected status change

  const handleStatusChange = (selectedOption, concernId) => {
    setStatusSelections({
      ...statusSelections,
      [concernId]: selectedOption?.value,
    });
  };

  //Submitting concern status

  const handleSubmitStatus = async (concernId) => {
    const selectedStatus = statusSelections[concernId];
    if (!selectedStatus) return;

    // Make comment mandatory for Resolved or Escalate
    if (
      (selectedStatus === "Resolved" || selectedStatus === "Escalate to Gurgaon Office") &&
      !comment.trim()
    ) {
      alert("Please specify how you resolved the concern or why you are escalating it.");
      return;
    }

    try {
      const query = {
        concernId: concernId,
      };

      const payload = {
        concernStatusByResolver: selectedStatus,
        ...(selectedStatus === "Resolved" || selectedStatus === "Escalate to Gurgaon Office"
          ? { commentByResolver: comment }
          : {}),
      };

      await PatchConcernsByQueryParams(query, payload);
      setComment(""); // clear comment after submission
      fetchTechConcerns(); // refresh after update
    } catch (error) {
      console.log("Error updating concern status", error);
    }
  };

  const progressPercent = 0;

  // Helper function for date formatting
  const formatDate = (isoString) => {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Container>
      <h1>School Concern Resolution</h1>
      {/* <div>
        <DistrictBlockSchoolById assignedDistricts={assignedDistricts} />
      </div> */}


        <div>
        <DistrictSchoolDropdown />
      </div>


      <div>
        <ClassOfStudent />
      </div>

      <hr />

      <div>
        {concernData.length > 0 ? (
          concernData.map((eachConcern, index) => {
            let progressPercent = 0;
            if (eachConcern.concernStatusBySubmitter === "Resolved") {
              progressPercent = 100;
            } else if (eachConcern.concernStatusByResolver === "Resolved") {
              progressPercent = 75;
            } else if (
              eachConcern.concernStatusByResolver === "Escalate to Gurgaon Office"
            ) {
              progressPercent = 50;
            } else if (eachConcern.concernStatusByResolver === "NA") {
              progressPercent = 0;
            }

            let options = [];
            if (eachConcern.concern === "SLC") {
              options = [
                { value: "SLC released", label: "SLC released" },
                { value: "Counselling required", label: "Counselling required" },
                { value: "Counselled", label: "Counselled" },
              ];
            } else if (eachConcern.concern === "Document") {
              options = [{ value: "Shared", label: "Shared" }];
            } else if (eachConcern.concern === "Academic") {
              options = [
                { value: "Resolved", label: "Resolved" },
                { value: "Not resolved", label: "Not resolved" },
              ];
            } else {
              options = [
                { value: "Resolved", label: "Resolved" },
                { value: "Escalate to Gurgaon Office", label: "Escalate to Gurgaon Office" },
              ];
            }

            let isEditable;
            let msgOfCard;
            if (userData?.role === "ACI") {
              isEditable = userData?.role === "ACI" && progressPercent >= 50;
            } else if (userData?.role === "Community Incharge") {
              isEditable =
                (userData?.role === "Community Incharge" &&
                  progressPercent <= 0) ||
                progressPercent >= 75;
            }

            // Determine card background color based on status
            let cardStyle = {};
            if (eachConcern.concernStatusByResolver === "Escalate to Gurgaon Office") {
              cardStyle.backgroundColor = "#FF8C00";
            } else if (eachConcern.concernStatusByResolver === "Resolved") {
              cardStyle.backgroundColor = "#7FFFD4";
            } else if (eachConcern.concernStatusBySubmitter === "Resolved") {
              cardStyle.backgroundColor = "#7fff9dff";
            }

            return (
              <div key={index}>
                <br />

                <Card className="school-concerns-resolution-card" style={cardStyle}>
                  <Card.Body>
                    <Card.Title style={{fontSize:'12px'}}>concern id: {eachConcern.concernId}</Card.Title>
                    <Card.Title>Student SRN: {eachConcern.studentSrn}</Card.Title>
                    <Card.Title>Concern Type: {eachConcern.concern}</Card.Title>
                    <Card.Title>Concern: {eachConcern.remark}</Card.Title>
                    <Card.Title>Class: {eachConcern.classOfConcern} </Card.Title>
                    {/* Display formatted date */}
                    <Card.Title>Date: {formatDate(eachConcern.dateOfSubmission)}</Card.Title>
                    <Card.Text>
                      <p>District: {eachConcern?.districtDetails?.districtName}</p>
                      <p>Center: {eachConcern?.schoolDetails?.schoolName}</p>
                      <hr></hr>
                      <p style={{ fontWeight: "bold" }}>Description:</p>
                      <p>{eachConcern.comment}</p>
                      <hr></hr>

                      <p>
                        Attachement:{" "}
                        {eachConcern.fileUrl ? (
                          <div>
                            <a href={eachConcern.fileUrl}>View file</a>
                          </div>
                        ) : (
                          "No attachement!"
                        )}
                      </p>
                      <hr></hr>
                    </Card.Text>
                    <div className="custom-progress-container">
                      <div
                        className="custom-progress-bar"
                        style={{ width: `${progressPercent}%` }}
                      ></div>
                      <div className="checkpoints">
                        <div
                          className={`checkpoint ${progressPercent >= 0 ? "active" : ""}`}
                          style={{ left: "0%" }}
                        >
                          <span>1</span>
                          <div className="checkpoint-label">Raised</div>
                        </div>
                        <div
                          className={`checkpoint ${progressPercent >= 25 ? "active" : ""}`}
                          style={{ left: "25%" }}
                        >
                          <span>2</span>
                          <div className="checkpoint-label">ACI</div>
                        </div>
                        <div
                          className={`checkpoint ${progressPercent >= 50 ? "active" : ""}`}
                          style={{ left: "50%" }}
                        >
                          <span>3</span>
                          <div className="checkpoint-label">GGN Office</div>
                        </div>

                        <div
                          className={`checkpoint ${progressPercent >= 75 ? "active" : ""}`}
                          style={{ left: "75%" }}
                        >
                          <span>3</span>
                          <div className="checkpoint-label">Resolved</div>
                        </div>

                        <div
                          className={`checkpoint ${progressPercent >= 100 ? "active" : ""}`}
                          style={{ left: "100%" }}
                        >
                          <span>4</span>
                          <div className="checkpoint-label">Closed</div>
                        </div>
                      </div>
                    </div>

                    <br />

                    <hr></hr>
                    <p style={{ fontWeight: "bold" }}>Resolver Remark:</p>
                    <p>{eachConcern.commentByResolver}</p>

                    <hr></hr>

                    <Select
                      options={options}
                      onChange={(selected) =>
                        handleStatusChange(selected, eachConcern.concernId)
                      }
                      value={
                        options.find(
                          (opt) =>
                            opt.value === statusSelections[eachConcern.concernId]
                        ) || null
                      }
                      placeholder="-- Select Status --"
                      isDisabled={isEditable}
                    />

                    {/* New Input for Comment if status is Resolved or Escalate */}
                    {(statusSelections[eachConcern.concernId] === "Resolved" ||
                      statusSelections[eachConcern.concernId] === "Escalate to Gurgaon Office") && (
                      <Form.Control
                        className="mt-2"
                        type="text"
                        placeholder="Please explain resolution or escalation reason"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    )}

                    <br />
                    <Button
                      id={eachConcern.concernId}
                      variant="primary"
                      onClick={(e) => handleSubmitStatus(eachConcern.concernId)}
                    >
                      Submit
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            );
          })
        ) : (
          <div>No concerns yet</div>
        )}
      </div>
    </Container>
  );
};
